module.exports = __webpack_public_path__ + "static/media/card5_3.dbf6394d.png";